export const LOCATION_SERVER = 'https://prod.api.aspectapp.io'
